module.exports = __webpack_public_path__ + "static/media/logo600x600.33965f80.png";